export default {
	product: {
		priceTypes: [
			{ code: 'ex-factory', label: 'Ex-factory price', condensedLabel: 'Ex-F' },
			{
				code: 'ex-factory-with-vat',
				label: 'Ex-factory price with VAT',
				condensedLabel: 'Ex-F+VAT',
			},
			{
				code: 'wholesale',
				label: 'Wholesale price without VAT',
				condensedLabel: 'Wh',
			},
			{
				code: 'wholesale-with-vat',
				label: 'Wholesale price with VAT',
				condensedLabel: 'Wh+VAT',
			},
			{
				code: 'retail',
				label: 'Retail price without VAT',
				condensedLabel: 'Ret',
			},
			{
				code: 'retail-with-vat',
				label: 'Retail price with VAT',
				condensedLabel: 'Ret+VAT',
			},
		],
		priceTypesOrder: [
			'ex-factory',
			'ex-factory-with-vat',
			'wholesale',
			'wholesale-with-vat',
			'retail',
			'retail-with-vat',
		],
		defaultPriceCurrency: 'EUR',
		defaultPriceType: 'ex-factory',
		chartPrices: [
			{
				code: 'ex-factory',
				label: 'Ex-factory price',
				color: '#E71D36',
				chartDot: 'square',
			},
			{
				code: 'ex-factory-with-vat',
				label: 'Ex-factory price with VAT',
				color: '#32BCDC',
				chartDot: 'rect',
			},
			{
				code: 'wholesale',
				label: 'Wholesale price without VAT',
				color: '#FF9F1C',
				chartDot: 'circle',
			},
			{
				code: 'wholesale-with-vat',
				label: 'Wholesale price with VAT',
				color: '#2D2F47',
				chartDot: 'cross',
			},
			{
				code: 'retail',
				label: 'Retail price without VAT',
				color: '#36A2EB',
				chartDot: 'diamond',
			},
			{
				code: 'retail-with-vat',
				label: 'Retail price with VAT',
				color: '#E866DD',
				chartDot: 'triangle',
			},
		],
	},
	analytics: {
		currencies: ['EUR', 'USD'],
		defaultCurrency: 'EUR',
	},
	userProductGroup: {
		maxRecentGroupsCount: 1,
		suklCodesSourceUrl: 'https://dostupnosti.cogvio.com/pricemonitor.html',
	},
	support: {
		email: 'support@cogvio.com',
	},
	api: {
		baseUrl: 'https://pricemonitor.cogvio.dev/api/v1/',
	},
	applicationUpdate: {
		hoursInterval: 2,
	},
	webFontLoader: {
		google: {
			families: ['Roboto:300,400,700:latin,latin-ext'],
		},
	},
	locale: ['en-GB'],
};
